import React from 'react';
import { FaWhatsapp, FaComments } from 'react-icons/fa';

const MessageCoach = ({ phoneNumber }) => {
  const hasPhoneNumber = phoneNumber && phoneNumber.trim() !== '';

  const getWhatsAppUrl = () => {
    if (!hasPhoneNumber) return '#';
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    const message = encodeURIComponent('Hi! I have a question about my fitness program.');
    return `https://wa.me/${cleanNumber}?text=${message}`;
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
          <FaComments className="text-xl text-green-600" />
        </div>
        <h3 className="text-lg font-bold text-gray-900">Message Coach</h3>
      </div>

      <p className="text-gray-600 text-sm mb-4">
        Have questions? Reach out to your coach anytime via WhatsApp.
      </p>

      {hasPhoneNumber ? (
        <a
          href={getWhatsAppUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white py-4 px-6 rounded-xl font-bold text-lg transition-colors"
        >
          <FaWhatsapp className="text-2xl" />
          Chat on WhatsApp
        </a>
      ) : (
        <div className="text-center py-6 px-4 bg-gray-50 rounded-xl">
          <FaWhatsapp className="text-4xl text-gray-300 mx-auto mb-3" />
          <p className="text-gray-500 text-sm">
            Coach contact will be available once your program starts.
          </p>
        </div>
      )}

      <p className="text-xs text-gray-500 mt-3 text-center">
        Typically responds within a few hours
      </p>
    </div>
  );
};

export default MessageCoach;
